// extracted by mini-css-extract-plugin
export default {"stockImg":"e_KdQe5dbOPhk7OV9HWC"};